<template>
  <b-card class="bg-white rounded-xl">
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">List of Podcast seasons</h2>

        <small class="text-muted">Manage all your Podcast seasons here. </small>
      </div>

      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="handleAdd"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon>Create
          Season</span
        >
      </base-button>
    </div>
    <PodcastTable />
  </b-card>
</template>

<script>
import PodcastTable from "./components/PodcastTable.vue";

export default {
  data() {
    return {
      categoryId: null,
      categoryName: null,
    };
  },
  components: {
    PodcastTable,
  },

  methods: {
    handleAdd() {
      this.$router.push({ name: "addPodcast" });
    },
  },
  async mounted() {
    await this.$store.dispatch("podcast/getall_category");
  },
};
</script>
